// =========================================================
// frontend/js/approvalflow.js - V9.0 (Robust & CSRD-Aware)
// =========================================================

window.APPROVAL_FLOW = {
    /**
     * Ermittelt den aktuell zuständigen Genehmiger für einen User
     */
    getResponsibleApprover: async function(userId) {
        // 1. User-Daten holen (Sicherheits-Check falls Liste leer)
        const users = window.usersList || [];
        const user = users.find(u => u.uid === userId);
        if (!user) {
            console.error("ApprovalFlow: User nicht gefunden:", userId);
            return this.getGlobalFallback();
        }

        // 2. Primären Vorgesetzten bestimmen
        let approverId = user.reportsTo;

        // 3. Fallback: Wenn kein Chef eingetragen, geht's an den Owner oder HR
        if (!approverId) {
            console.warn("Kein Vorgesetzter für", userId, "hinterlegt. Eskalation an Fallback.");
            return this.getGlobalFallback();
        }

        // 4. Verfügbarkeits-Check: Ist der Chef selbst "Out of Office"?
        const isAvailable = await this.checkAvailability(approverId);
        
        if (!isAvailable) {
            console.log("Chef ist abwesend. Suche Stellvertreter...");
            const approverUser = users.find(u => u.uid === approverId);
            
            // Wenn der Chef einen Stellvertreter (Substitute) definiert hat, nimm diesen
            if (approverUser?.substituteId) {
                return approverUser.substituteId;
            }
            
            // Wenn kein Stellvertreter da ist, eskaliere eine Ebene höher
            // (Hier könnte man noch die getHigherLevelApprover implementieren)
            return this.getGlobalFallback();
        }

        return approverId;
    },

    /**
     * Prüft, ob ein User heute im Dienst ist (kein Urlaub/Krank)
     */
    checkAvailability: async function(uid) {
        // Sicherstellen, dass wir ein sauberes Vergleichsdatum haben
        const today = new Date();
        const todayStr = today.toISOString().split('T')[0];
        
        const events = window.events || [];
        
        // Suche nach Abwesenheiten für heute
        const absence = events.find(e => {
            // WICHTIG: Sicherheitscheck auf e.date (verhindert den Split-Fehler!)
            if (!e.date || !e.userId || e.userId !== uid) return false;
            
            const type = (e.type || '').toUpperCase();
            const isAbsence = type === 'VACATION' || type === 'SICK' || type === 'URLAUB' || type === 'KRANK';
            
            return isAbsence && e.status === 'APPROVED' && e.date === todayStr;
        });
        
        return !absence; // Wahr, wenn keine Abwesenheit gefunden wurde
    },

    /**
     * Fallback-Logik: Wer ist im Zweifel verantwortlich?
     */
    getGlobalFallback: function() {
        const users = window.usersList || [];
        // Sucht den ersten User mit der Rolle HR oder den Owner
        const fallback = users.find(u => u.role === 'HR' || u.role === 'OWNER');
        return fallback ? fallback.uid : null;
    }
};